export default {
  note: {
    title: 'Besondere Hinweise:',
    description:
      'Wir geben unser Bestes, um Wünsche zu berücksichtigen, aber können keine Änderungen vornehmen, die den Preis beeinflussen.',
    placeholder: 'Sonderwunsch hinzufügen',
  },
  buttons: {
    update_item: 'Aktualisieren',
    add_to_card: 'Hinzufügen',
    add: '+ Artikel',
  },
  error_messages: {
    missing_fields: 'Bitte wähle alle erforderlichen Felder aus.',
    product_unavailable: 'Ausverkauft!',
  },
  labels: {
    bogo: '2 für 1',
  },
};
